import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home from "./Home";
import Gallery from "./components/events/Gallery";
import emailjs from "emailjs-com";
import NewsletterPage from "./components/news/newsletter/NewsletterPage.jsx";
import MemberPage from "./components/team/members/MemberPage.jsx";
import SponsorsPage from "./components/sponsors/SponsorsPage.jsx";
import Departments from "./components/team/Team.jsx";
import OpenSourcePage from "./OpenSourcePage";
import AtlanticoPage from "./components/atlantico/AtlanticoPage";
import NewsPage from "./components/news/NewsPage.jsx";
import EventsPage from "./components/events/EventsPage.jsx";
import { MembersProvider } from "./context/membersContext.tsx";

function App() {
  useEffect(() => emailjs.init(process.env.REACT_APP_EMAIL_PUBLIC_USER_ID), []);

  return (
    <BrowserRouter>
      <MembersProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:id" element={<Gallery />} />
          <Route path="/newsletter/:id" element={<NewsletterPage />} />
          <Route path="/member/:id" element={<MemberPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/opensource" element={<OpenSourcePage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/atlantico" element={<AtlanticoPage />} />
          <Route path="/news" element={<NewsPage />} />
        </Routes>
      </MembersProvider>
    </BrowserRouter>
  );
}

export default App;